import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";
import { Loader2, ShieldCheck } from "lucide-react";
import { apiClient } from "../lib/api";
import Header from "../components/Header";

export default function AdminLogin() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("admin@dokterzon.es");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await apiClient.post("/admin/login", { email, password });
      localStorage.setItem("dz_admin_token", r.data.token);
      toast.success(t("admin.login.welcome"));
      nav("/admin/dashboard");
    } catch (err) {
      toast.error(t("admin.login.invalid"));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#FFFFFF]">
      <Header minimal />
      <div className="max-w-md mx-auto px-6 py-20">
        <div className="bg-white rounded-xl border border-[#FFF7ED] p-8">
          <ShieldCheck className="w-10 h-10 text-[#E78938] mb-4" strokeWidth={1.5} />
          <h1 className="serif text-3xl text-[#0F172A] mb-1">{t("admin.login.title")}</h1>
          <p className="text-sm text-[#475569] mb-8">{t("admin.login.subtitle")}</p>
          <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
            <div>
              <label htmlFor="admin-email" className="block text-xs uppercase tracking-wider text-[#475569] mb-1.5 font-semibold">{t("admin.login.email")}</label>
              <input id="admin-email" data-testid="admin-email" type="email" placeholder={t("admin.login.email_placeholder")}
                value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-[#FFF7ED] border border-[#FED7AA] rounded-xl px-4 py-3 text-[#0F172A] placeholder:text-[#94A3B8] outline-none focus:bg-white focus:border-[#E78938] focus:ring-2 focus:ring-[#E78938]/40 transition" />
            </div>
            <div>
              <label htmlFor="admin-password" className="block text-xs uppercase tracking-wider text-[#475569] mb-1.5 font-semibold">{t("admin.login.password")}</label>
              <input id="admin-password" data-testid="admin-password" type="password" placeholder={t("admin.login.password_placeholder")}
                value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-[#FFF7ED] border border-[#FED7AA] rounded-xl px-4 py-3 text-[#0F172A] placeholder:text-[#94A3B8] outline-none focus:bg-white focus:border-[#E78938] focus:ring-2 focus:ring-[#E78938]/40 transition" />
            </div>
            <button data-testid="admin-submit" type="submit" disabled={busy} className="w-full bg-[#0F172A] text-white rounded-xl px-6 py-3 hover:bg-[#3a3835] transition flex items-center justify-center gap-2">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : t("admin.login.submit")}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
